(function($){

    //SINGLE prodotto

    $(document).on( 'click tap touchend', '.video-wrapper .play', function(e) {

        if ($(".video").get(0).paused) {
            $(".video").get(0).play();
            $(this).addClass('smx-hide');
            $(this).parent().addClass('triggerable');
        } else {
            $(".video").get(0).pause();
            $(this).removeClass('smx-hide');
            $(this).parent().removeClass('triggerable');
        }

    });

    $(document).on( 'click tap touchend', '.triggerable', function(e) {

        if ($(".video").get(0).paused) {
           
        } else {
            $(".video").get(0).pause();
            $(this).removeClass('triggerable');
            $(this).find('.play').removeClass('smx-hide');
        }

    });


    $(document).ready(function() {

        //START video in background
        $('[data-youtube]').youtube_background();
        //STOP video in background

    });

})
(jQuery);
